module.exports = __webpack_public_path__ + "e97fb2bbf93ba5225434cc8034769d9c.png";